import { defineAsyncComponent } from 'vue'
export default {
  "admin-auth": defineAsyncComponent(() => import("/home/runner/work/hub-of-hope/hub-of-hope/layouts/admin-auth.vue")),
  default: defineAsyncComponent(() => import("/home/runner/work/hub-of-hope/hub-of-hope/layouts/default.vue")),
  "email-auth": defineAsyncComponent(() => import("/home/runner/work/hub-of-hope/hub-of-hope/layouts/email-auth.vue")),
  iframe: defineAsyncComponent(() => import("/home/runner/work/hub-of-hope/hub-of-hope/layouts/iframe.vue")),
  "nav-simple": defineAsyncComponent(() => import("/home/runner/work/hub-of-hope/hub-of-hope/layouts/nav-simple.vue"))
}